const links = {
  personal: [
    { name: "gmail", url: "https://mail.google.com/mail/" },
    { name: "whatsapp", url: "https://web.whatsapp.com/" },
    { name: "google calendar", url: "https://calendar.google.com/calendar/" },
    { name: "algo-expert questions", url: "https://www.algoexpert.io/questions"},
  ],
  devTools: [
    { name: "github", url: "https://www.github.com/tymonaghan" },
    {
      name: "tylermonaghan.dev DNS",
      url: "https://domains.google.com/registrar/tylermonaghan.dev/dns?hl=en",
    },
  ],
  hockey: [
    { name: "BenchApp", url: "https://www.benchapp.com/player/dashboard" },
    {
      name: "FTA registration",
      url: "https://member.daysmartrecreation.com/#/online/blackhawks/dashboard",
    },
    { name: "bracket challenge", url: "https://bracketchallenge.nhl.com/en/dashboard" },
    {
      name: "ESPN FHL",
      url: "https://fantasy.espn.com/hockey/team?leagueId=50104176&teamId=1",
    },
  ],
  watch: [
    { name: "YouTubeTV", url: "https://tv.youtube.com/" },
    { name: "Paramount+", url: "https://www.paramountplus.com/my-list/" },
    {
      name: "ESPN+",
      url: "https://www.espn.com/watch/espnplus/",
    },
  ],
};

export default links;
